/*
 * The recon variants (Card variant="recon", Button variant="recon-*", IconButton variant="recon") read the Recon roles
 * that products.recon defines in packages/tokens/src/themes.ts. Every read carries a base fallback, so the variants
 * still render in a product without those roles; only Recon gets the shipped Recon look. Recon modifier classes (for
 * example .empty.good) restyle one card by setting a role on that element, so a role read here is the only override
 * path the app needs. Roles are read by name here and nowhere else.
 */
export const RECON_ROLES = [
  'card-fill',
  'card-edge',
  'card-backdrop',
  'button-hover',
  'warn-edge',
  'danger-edge',
  'danger-ink',
  'cta-fill',
  'cta-shadow',
  'cta-hover-shadow',
  'overlay-fill',
  'overlay-edge',
  'overlay-ink',
  'segment-on-fill',
  'segment-on-shadow',
] as const;

export type ReconRole = (typeof RECON_ROLES)[number];

export const reconVar = (name: ReconRole): string => `--recon-${name}`;

export const reconRole = (name: ReconRole, fallback: string | number): string => `var(${reconVar(name)}, ${fallback})`;

/* New Card options use canonical roles. Shipped fill, edge and backdrop roles stay compatible. */
export const RECON_CARD_ROLES = ['radius', 'shadow', 'border-style'] as const;
export type ReconCardRole = (typeof RECON_CARD_ROLES)[number];
export const reconCardVar = (name: ReconCardRole): string => `--rv-recon-card-${name}`;
export const reconCardRole = (name: ReconCardRole, fallback: string | number): string =>
  `var(${reconCardVar(name)}, ${fallback})`;

/* Shipped Recon motion (--dur-hover, --dur-press), off-scale. */
export const RECON_HOVER_MS = 170;
export const RECON_PRESS_MS = 110;
